/**
 * The join code arrives in the URL FRAGMENT (#/join/<code>) so it never
 * reaches the CDN, server logs, or Referer headers. Read it once on boot and
 * immediately scrub it from the address bar / history (plan v4 §2.5).
 */
export function takeJoinCodeFromFragment(): string | null {
  const match = window.location.hash.match(/^#\/join\/([A-Za-z0-9_-]+)$/)
  if (!match) return null

  history.replaceState(null, '', window.location.pathname + window.location.search)
  return match[1]
}
